<main id="main-content" tabindex="-1">
  <div class="max-h-fit px-0 md:px-4 lg:px-20 pt-10">
    <div class="grid grid-cols-2 py-5">
      <div class="col-span-2 lg:col-span-1 items-center pb-4">
        <h1 class="text-dark-purple text-3xl font-bold">Schools</h1>
      </div>
        <div class="col-span-2 pb-4 flex flex-col md:flex-row md:justify-end">
          @if (!isDistrictAdmin) {
            <prism-btn
                btnClass="bg-white text-dark-purple font-bold border-2 p-0 m-0 rounded-xl border-dark-purple"
                (click)="addSchool()">
            <i class="uil uil-plus text-dark-purple font-bold pr-1"></i>Add School
            </prism-btn>
          }
        </div>
          <div class="col-span-2 grid grid-cols-1 lg:grid-cols-12 gap-4 pb-4 items-start">
            <div class="lg:col-span-5">
              <prism-input
                inputType="text"
                [control]="searchForm.get('search')"
                [required]="false"
                placeHolder="Search for School"
                [hasSearch]="true"
                (search)="searchSchools()">
              </prism-input>
            </div>

            <div class="hidden lg:block lg:col-span-3"></div>

            <div class="lg:col-span-4 lg:col-start-9 w-full">
              <prism-select-organization
                [control]="searchForm.get('organizationId')"
                [required]="false">
              </prism-select-organization>
            </div>
          </div>

    </div>
    <div>
    <prism-table [columns]="columns"
                [colHeaders]="colHeaders"
                [tableData]="data"
                [isDelete]="true"
                [isEdit]="true"
                [pageIndex]="pageIndex"
                [pageSize]="pageSize"
                [totalData]="totalData"
                (edit)="editSchool($event)"
                (pageIndexChange)="handlePageIndexChange($event)"
                (pageSizeChange)="handlePageSizeChange($event)"
                (delete)="deleteSchool($event)"
                [hideActionBtns]="isDistrictAdmin"
                (columnDirectionChange)="handleColumnDirectionChange($event)">
    </prism-table>
  </div>
  </div>
</main>
<nz-modal [(nzVisible)]="isVisible" [nzTitle]="modalTitle" nzOkText="Save" (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()" [nzOkDisabled]="schoolForm.pristine">
  <ng-container *nzModalContent>
    <form class="grid gap-4" [formGroup]="schoolForm">
        <prism-input
            [control]="schoolForm.get('name')"
            placeHolder="Enter school name"
            label="School Name"
            [required]="true"
            inputType="text"
            [maxLength]="150">
        </prism-input>

      <div class="col-span-1">
        <prism-select-organization
          [control]="schoolForm.get('districtId')"
          label="District"
          placeHolder="Select a District"
          [required]="true"
          [readOnly]="isDistrictAdmin">
        </prism-select-organization>
      </div>
    </form>
  </ng-container>
</nz-modal>
